import { UPDATE_META } from '../actions/meta';

const defaultState = {
  title: 'New Song',
  authors: '',
  key: '',
  filename: '',
  tempo: '',
  sentence: '',
};

const meta = (state = defaultState, action) => {
  switch (action.type) {
  case UPDATE_META:
    return {
      ...state,
      ...action.obj,
    };

  default:
    return state;
  }
};

export default meta;



// WEBPACK FOOTER //
// ./src/reducers/meta.js